// extracted by mini-css-extract-plugin
export default {"link":"f0i8HC","ShinyGradientButton":"oAG3UF","shinyGradientButton":"oAG3UF","label":"taJ2pD","mainColor":"ZU6zNI","pose":"cwDrMg","topper":"KHy8_H","oval":"IiLlHl","bord":"AMpEEf"};